import { RentalActionTypes } from './actionTypes';
import { RentalMapper } from 'mappers/rentals';
import { CommonMapper } from 'mappers/common';
import { ProjectActionTypes } from 'modules/project/actionTypes';

const getRentals = type => (dispatch, getState, { api }) => {
  dispatch({
    type: RentalActionTypes.RENTAL.FETCH,
    payload: {},
    test: api
      .post(`getHomeForRentals.json`, { project_type: type })
      .then(res => {
        const response = res.data.data || {};
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RentalActionTypes.RENTAL.SUCCESS,
          payload: RentalMapper.mapRentalHomes(response, mediaPath),
        });
        dispatch({
          type: RentalActionTypes.RENTAL_FILTERS.INITIALIZE,
          payload: RentalMapper.mapRentalFilters(response, mediaPath),
        });
        dispatch({
          type: RentalActionTypes.RENTAL_ADVERT.SUCCESS,
          payload: RentalMapper.mapAdvertisementSection(response, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: RentalActionTypes.RENTAL.FAILURE,
          error,
        });
      }),
  });
};

const getRentalDetails = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: RentalActionTypes.RENTAL_DETAIL.FETCH,
    payload: {},
    test: api
      .post(`getRentalHomeDetails.json`, {
        rental_home_url_slug: url_slug,
      })
      .then(res => {
        const response = res.data.data || {};
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RentalActionTypes.RENTAL_DETAIL.SUCCESS,
          payload: RentalMapper.mapRentalDetailBanner(response, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: RentalActionTypes.RENTAL_DETAIL.FAILURE,
          error,
        });
      }),
  });
};

const toggleRentalFilter = (type, value) => dispatch => {
  dispatch({
    type: RentalActionTypes.RENTAL_FILTERS.TOGGLE_FILTER,
    payload: {
      type,
      value,
    },
  });
};

const clearRentalFilters = () => dispatch => {
  dispatch({
    type: RentalActionTypes.RENTAL_FILTERS.CLEAR_FILTERS,
  });
};

const getRentalsFeature = url_slug => (dispatch, getState, { api }) => {
  dispatch({
    type: RentalActionTypes.RENTAL.FETCH,
    payload: {},
    test: api
      .post(`getFeaturesForRentalHome.json`, {
        rental_home_url_slug: url_slug,
      })
      .then(res => {
        const response = res.data.data || {};
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: RentalActionTypes.RENTALFEATURE.SUCCESS,
          payload: RentalMapper.mapRentalFeature(response, mediaPath),
        });
      })
      .catch(error => {
        dispatch({
          type: RentalActionTypes.RENTALFEATURE.FAILURE,
          error,
        });
      }),
  });
};
const getGalleryForRental = (rental_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProjectActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        model: 'rental homes',
        url_slug: rental_url_slug,
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ProjectActionTypes.GALLERY.SUCCESS,
          payload: CommonMapper.mapGalleryImages(galleryImages, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};
export const RentalActions = {
  getRentals,
  getRentalDetails,
  toggleRentalFilter,
  clearRentalFilters,
  getRentalsFeature,
  getGalleryForRental,
};
